
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/mPOS",
      function () {
        return require("private-next-pages/mPOS.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/mPOS"])
      });
    }
  